import { StoredValueAction, StoredValueLog } from 'core/storedValue/StoredValueLog';
import { formatPrice, formatPriceWithCurrency } from 'helper/CurrencyHelper';
import styles from './storedValueDetail.module.scss';
import { FREEZE_ACTIONS } from 'core/storedValue/StoredValueManager';

export type ExcelCellData = {
  text: string;
  isRed: boolean;
};

export const priceFormatter = (value: number, record: StoredValueLog) => {
  if (value < 0) {
    return (
      <span className={styles.danger}>
        {formatPriceWithCurrency(record.currency, value)}
      </span>
    );
  }
  return formatPriceWithCurrency(record.currency, value);
};

export const amountFormatter = (value: number, record: StoredValueLog) => {
  if (FREEZE_ACTIONS.includes(record.action)) {
    return undefined;
  }
  if (value < 0) {
    return (
      <span className={styles.danger}>
        {formatPriceWithCurrency(record.currency, value)}
      </span>
    );
  }
  return `${record.currency} +${formatPrice(record.currency, value)}`;
};

export const freezeAmountFormatter = (_1: any, record: StoredValueLog) => {
  if (!FREEZE_ACTIONS.includes(record.action)) {
    return undefined;
  }
  switch (record.action) {
    case StoredValueAction.UNFREEZE_BUDGET:
      return `${record.currency} -${formatPrice(record.currency, record.amount)}`;
    case StoredValueAction.FREEZE_BUDGET:
      return (
        <span className={styles.danger}>
          {`${record.currency} +${formatPrice(record.currency, record.amount)}`}
        </span>
      );
    case StoredValueAction.REMOVE_FREEZE_BUDGET:
      return (
        <span className={styles.danger}>
          {`${record.currency} -${formatPrice(record.currency, record.amount)}`}
        </span>
      );
    default:
      return undefined;
  }
};

// Excel-specific formatters (return plain text with red flag)
export const priceFormatterForExcel = (value: number, record: StoredValueLog): ExcelCellData => {
  const text = formatPriceWithCurrency(record.currency, value);
  return { text, isRed: value < 0 };
};

export const amountFormatterForExcel = (value: number, record: StoredValueLog): ExcelCellData => {
  if (FREEZE_ACTIONS.includes(record.action)) {
    return { text: '', isRed: false };
  }
  if (value < 0) {
    return {
      text: formatPriceWithCurrency(record.currency, value),
      isRed: true
    };
  }
  return {
    text: `${record.currency} +${formatPrice(record.currency, value)}`,
    isRed: false
  };
};

export const freezeAmountFormatterForExcel = (_1: any, record: StoredValueLog): ExcelCellData => {
  if (!FREEZE_ACTIONS.includes(record.action)) {
    return { text: '', isRed: false };
  }
  switch (record.action) {
    case StoredValueAction.UNFREEZE_BUDGET:
      return {
        text: `${record.currency} -${formatPrice(record.currency, record.amount)}`,
        isRed: false
      };
    case StoredValueAction.FREEZE_BUDGET:
      return {
        text: `${record.currency} +${formatPrice(record.currency, record.amount)}`,
        isRed: true
      };
    case StoredValueAction.REMOVE_FREEZE_BUDGET:
      return {
        text: `${record.currency} -${formatPrice(record.currency, record.amount)}`,
        isRed: true
      };
    default:
      return { text: '', isRed: false };
  }
};
